// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"cdb5a276","40":"70e41396","182":"c4f476d2","453":"b72d7662","457":"1c0362c6","591":"a395576c","596":"8a290b3c","911":"1b21b653","913":"3895fab8"}[chunkId] + ".chunk.js";
};